import Ratio from './Ratio2.vue';

// @ts-ignore
Ratio.install = (Vue) => {
  Vue.component((Ratio as any).options.name, Ratio);
};

export default Ratio;
